import { render, staticRenderFns } from "./SpecialGoods.vue?vue&type=template&id=42a8bcfc&scoped=true"
import script from "./SpecialGoods.vue?vue&type=script&lang=js"
export * from "./SpecialGoods.vue?vue&type=script&lang=js"
import style0 from "./SpecialGoods.vue?vue&type=style&index=0&id=42a8bcfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a8bcfc",
  null
  
)

export default component.exports